import React, {Component} from 'react';
import {getDisplacements} from "./MechanicsEngine";
import {vector} from "./Vector";

export class MechanicsView extends Component {
    static displayName = MechanicsView.name;

    constructor(props) {
        super(props);
        this.state = {
            objects: props.objects,
            forces: props.forces,
            size: props.size,
            walls: props.walls,
            reportClick: props.onClick,
            reportObjectClick: props.onObjectClick,
            dt: props.dt ?? 0.05,
            animationTimeStep: props.animationTimeStep ?? 10
        };
        this.handleObjectClick = this.handleObjectClick.bind(this);
        this.handleSvgClick = this.handleSvgClick.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.objects.length !== state.objects.length) {
            return {objects: props.objects};
        }
        if (props.forces.length !== state.forces.length) {
            return {forces: props.forces};
        }
        return null;
    }

    componentDidMount() {
        this.countDown();
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    countDown() {
        const passTime = () => {
            const displacedObjects = [];
            const displacements = getDisplacements(this.state.objects, this.state.forces, this.state.dt);
            this.state.objects.forEach((item, index) => {
                const displacement = displacements[index];
                item.r = vector.add(item.r, displacement.r);
                item.v = vector.add(item.v, displacement.v);
                displacedObjects.push(item);
            });
            this.setState({objects: displacedObjects});
        };
        const timer = setInterval(passTime, this.state.animationTimeStep);
        this.setState({timer: timer});
    }

    handleSvgClick(event) {
        if (!this.state.reportClick) return;
        if (event.target.nodeName !== "svg") return;

        const svgPosition = event.target.getBoundingClientRect();
        const x = event.clientX - svgPosition.x;
        const y = event.clientY - svgPosition.y;
        this.state.reportClick({clickPosition: {x: x, y: y}});
    }

    handleObjectClick(event) {
        if (!this.state.reportObjectClick) return;

        const id = event.target.id;
        this.state.reportObjectClick({objectId: id});
    }

    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" onClick={this.handleSvgClick}
                 width={this.state.size.width + "px"} height={this.state.size.height + "px"}>
                {this.state.walls?.map(wall =>
                    <line key={wall.id} x1={wall.x1} y1={wall.y1} x2={wall.x2} y2={wall.y2} stroke="black"
                          strokeWidth={wall.width}/>
                )}
                {this.state.objects.map(item =>
                    <circle id={item.id} key={item.id} cx={Math.round(item.r.x) + "px"}
                            cy={Math.round(item.r.y) + "px"}
                            r={item.radius + "px"} fill={item.color} onClick={this.handleObjectClick}/>
                )}
            </svg>
        );
    }
}
